//动物类型
export const animalTypeOptions = [
  {value: '肉鸡',label: '肉鸡',children: [{value: '白羽',label: '白羽'},{value: '有色羽',label: '有色羽',}]},
  {value: '肉鸭',label: '肉鸭',children: [{value: '白羽',label: '白羽'},{value: '有色羽',label: '有色羽',}]},
]
//动物
export const animalTypeList = [
  {
    id:1,name: '蛋鸡',VarietyDepotCode:'eggTypeChickens',LabelCode:'positiveEggChickens',
    feedModeList:[{id:1, name: '全封闭笼养'}, {id:2, name: '半封闭笼养'},],
  },
  {
    id:2,name: '蛋鸭',VarietyDepotCode:'eggTypeDucks',LabelCode:'positiveEggDucks',
    feedModeList:[{id:1, name: '水养'}, {id:2, name: '旱养'},{id:3, name: '笼养'}]
  }
]
